import { render, staticRenderFns } from "./ContactUS.vue?vue&type=template&id=fb18a956&scoped=true&"
import script from "./ContactUS.vue?vue&type=script&lang=js&"
export * from "./ContactUS.vue?vue&type=script&lang=js&"
import style0 from "./ContactUS.vue?vue&type=style&index=0&id=fb18a956&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb18a956",
  null
  
)

export default component.exports